import React, { useEffect, useState } from 'react';
import { noop } from '@prisjakt/ui-base';

import Rating from 'src/components/rating';
import ErrorBoundary from 'src/components/error-boundary';
import { LinkToReviews } from '../LinkToReviews';
import { ProductFilters } from 'src/areas/product/components/product-filters';

import { OurChoiceProps, ProductHeaderProps } from '../../types';
import { Category, Maybe } from 'src/types';

import {
  CampaignBadge,
  MainSection,
  MobileHeader,
  ProductMedia,
  StyledRating,
  Title,
  TitleWrapper,
} from './styles';
import { ActionButtonsMobile } from './action-buttons';
import { getProductMedia } from '../../utils';
import { OurChoice } from '../../../price-list/price-row/row-types/our-choice';
import { useOurChoiceExperiment } from 'src/hooks/experiments';

export const ProductHeaderMobile: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ProductHeaderProps & OurChoiceProps>
>> = props => {
  const { title, product, currentCampaign, ourChoice, ourChoiceOffer } = props;

  const [
    ourChoiceExperimentIsEnabled,
    setOurChoiceExperimentIsEnabled,
  ] = useState(false);
  const ourChoiceExperiment = useOurChoiceExperiment();

  useEffect(() => {
    setOurChoiceExperimentIsEnabled(ourChoiceExperiment);
  }, [ourChoiceExperiment]);

  if (!product) {
    return null;
  }

  return (
    <MobileHeader data-test="MobileProductHeader">
      <MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {props.currentCampaign ? (
                <CampaignBadge
                  colors={props.currentCampaign.media.colors}
                  size="large"
                />
              ) : null}
              <ProductMedia
                name={product.name}
                media={getProductMedia(product.media)}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <div>
          <TitleWrapper>
            <Title data-test="ProductTitle">{title}</Title>

            <ActionButtonsMobile product={product} />
          </TitleWrapper>

          <LinkToReviews>
            {product.userReviewSummary &&
            product.userReviewSummary.count !== 0 ? (
              <StyledRating>
                <Rating
                  hide={product.userReviewSummary.count === 0}
                  rate={product.userReviewSummary.rating}
                  count={product.userReviewSummary.count}
                  size="medium"
                  showRate
                  showRateAs="number"
                  showCounterAs="number"
                  linked
                />
              </StyledRating>
            ) : null}
          </LinkToReviews>
        </div>
      </MainSection>

      <ProductFilters
        category={product.category as Maybe<Category>}
        product={product}
      />

      {ourChoiceExperimentIsEnabled && ourChoice && (
        <div>
          <OurChoice
            ourChoice={ourChoice}
            product={product}
            campaign={currentCampaign}
            offer={ourChoiceOffer}
            showExpandButton={false}
          />
        </div>
      )}
    </MobileHeader>
  );
};
